import React from 'react';
import multiavatar from '@multiavatar/multiavatar';

const Avatar = ({ id }) => {
  const avatarSvg = multiavatar(id);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: avatarSvg }}
      style={{ width: '28px', height: '28px'}}
    />
  );
};

export default Avatar;
